var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Expired50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACC1",
    d: "M17 3A14 14 0 1 0 17 31A14 14 0 1 0 17 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M17 6A11 11 0 1 0 17 28A11 11 0 1 0 17 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H18V17H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 16H20.599999999999998V22.8H18.2z",
    transform: "rotate(134.999 19.4 19.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15A2 2 0 1 0 17 19A2 2 0 1 0 17 15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACC1",
    d: "M17 16A1 1 0 1 0 17 18A1 1 0 1 0 17 16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M11.9,42l14.4-24.1c0.8-1.3,2.7-1.3,3.4,0L44.1,42c0.8,1.3-0.2,3-1.7,3H13.6C12.1,45,11.1,43.3,11.9,42z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26.4,39.9c0-0.2,0-0.4,0.1-0.6s0.2-0.3,0.3-0.5s0.3-0.2,0.5-0.3s0.4-0.1,0.6-0.1s0.5,0,0.7,0.1s0.4,0.2,0.5,0.3s0.2,0.3,0.3,0.5s0.1,0.4,0.1,0.6s0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5s-0.3,0.2-0.5,0.3s-0.4,0.1-0.7,0.1s-0.5,0-0.6-0.1s-0.4-0.2-0.5-0.3s-0.2-0.3-0.3-0.5S26.4,40.1,26.4,39.9z M29.2,36.8h-2.3L26.5,27h3L29.2,36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Expired50);
export default __webpack_public_path__ + "static/media/icons8-expired-50.57c927dc01bb2d8367d4de8015217a77.svg";
export { ForwardRef as ReactComponent };